import './index.styl'

export default {
  name: 'NotFound',
  created() {
    window.document.title = '404'
  },
  render() {
    return (
      <div class="not-found-page">
        <img src="https://image.wxopen.shenhudong.com/v4-wechat-fonted/static/icon/not-found.svg" alt="image" />
        <div class="desc">网络开小差了，稍后再试一下</div>
      </div>
    )
  }
}